import { RovingFocusGroup } from "@tamagui/roving-focus";
import { forwardRef } from "react";
import { Group, H2, Checkbox as TCheckbox, styled, withStaticProperties, isWeb, createStyledContext, Label, View } from "tamagui";
import { jsx } from "react/jsx-runtime";
const CheckboxesContext = createStyledContext({
  values: {},
  onValuesChange: () => {}
});
const FocusGroup = forwardRef((props, ref) => {
  return /* @__PURE__ */jsx(RovingFocusGroup, {
    focusable: true,
    outlineOffset: 1,
    focusStyle: {
      z: 1e3
    },
    ...props,
    ref
  });
});
const FocusItemContext = createStyledContext({
  value: ""
});
const FocusGroupItem = forwardRef((props, ref) => {
  const {
    value,
    ...rest
  } = props;
  const {
    values,
    onValuesChange
  } = CheckboxesContext.useStyledContext();
  const attrs = {
    focusable: true,
    outlineOffset: 1,
    flexShrink: 1,
    focusStyle: {
      z: 1
    },
    ...(isWeb && {
      onKeyDown: e => {
        if (e.target !== e.currentTarget) return;
        if (e.key === "Enter" || e.code === "Space") onValuesChange({
          ...values,
          [value]: !values[value]
        });
      }
    }),
    onPress: () => {
      onValuesChange({
        ...values,
        [value]: !values[value]
      });
    },
    ...rest
  };
  return /* @__PURE__ */jsx(FocusItemContext.Provider, {
    value,
    children: /* @__PURE__ */jsx(RovingFocusGroup.Item, {
      ref,
      ...attrs
    })
  });
});
const RadiusGroup = styled(Group, {
  orientation: "vertical"
});
const Title = styled(H2, {
  size: "$8"
});
const CheckboxesImp = props => {
  const {
    values,
    onValuesChange,
    ...rest
  } = props;
  return /* @__PURE__ */jsx(CheckboxesContext.Provider, {
    values,
    onValuesChange,
    children: /* @__PURE__ */jsx(View, {
      ...rest
    })
  });
};
const Checkbox = TCheckbox.styleable((props, ref) => {
  const {
    checked: userChecked,
    onCheckedChange,
    ...rest
  } = props;
  const {
    values,
    onValuesChange
  } = CheckboxesContext.useStyledContext();
  const {
    value: focusItemValue
  } = FocusItemContext.useStyledContext();
  const attrs = {
    checked: values[focusItemValue],
    onCheckedChange: checked => {
      onValuesChange({
        ...values,
        [focusItemValue]: typeof checked === "boolean" ? checked : !values[focusItemValue]
      });
    },
    ...rest
  };
  return /* @__PURE__ */jsx(TCheckbox, {
    ref,
    value: focusItemValue,
    ...rest,
    ...attrs
  });
});
const CardFrame = styled(View, {
  cursor: "pointer",
  width: "100%",
  rounded: "$4",
  p: "$3",
  bg: "$background",
  borderColor: "$borderColor",
  borderWidth: 1,
  focusStyle: {
    bg: "$backgroundFocus",
    borderColor: "$borderColorFocus"
  },
  hoverStyle: {
    bg: "$backgroundHover",
    borderColor: "$borderColorHover"
  },
  pressStyle: {
    bg: "$backgroundPress",
    borderColor: "$borderColorPress"
  },
  variants: {
    active: {
      true: {
        backgroundColor: "$backgroundFocus",
        borderColor: "$borderColorFocus"
      }
    }
  }
});
const Card = CardFrame.styleable((props, ref) => {
  const {
    ...rest
  } = props;
  const {
    values
  } = CheckboxesContext.useStyledContext();
  const {
    value
  } = FocusItemContext.useStyledContext();
  const selected = values[value];
  return /* @__PURE__ */jsx(CardFrame, {
    ref,
    active: selected,
    ...rest
  });
});
const Checkboxes = withStaticProperties(CheckboxesImp, {
  Group: withStaticProperties(RadiusGroup, {
    Item: Group.Item
  }),
  FocusGroup: withStaticProperties(FocusGroup, {
    Item: FocusGroupItem
  }),
  Title,
  Checkbox: withStaticProperties(Checkbox, {
    Indicator: TCheckbox.Indicator,
    Label
  }),
  Card
});
export { Checkboxes };
//# sourceMappingURL=checkboxParts.mjs.map
